// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2G8g-","title":"AfterFrontImage_title__pjcUz"};